import React, { useContext, useEffect, useState } from "react";
import { BuilderContext, useDrawer } from "react-flow-builder";
import { Form, Button, Input, message, Radio, Checkbox, Modal} from "antd";
import { CopyOutlined } from "@ant-design/icons";
import { store } from "../../../../../../../redux";
import { setDraft } from "../../../../../../../redux/actions/skill";
import { notify } from "../../../../../../../redux/actions/snackActions";
import TextArea from "antd/lib/input/TextArea";
import { useDispatch, useSelector } from "react-redux";
import info from "../../../../../../../images/info.png"
import CodeEditor from "@uiw/react-textarea-code-editor";
import sampleData from "../../sampleData"
import CopyToClipboard from "react-copy-to-clipboard";
import { action } from "../../../../../CreateTemplateStudio/components/TemplateMapper/ManageActions";
import { GenAIConfigurer } from "./genaiConfigurer";
const SendMailConfigForm = () => {
  const dispatch = useDispatch();
  let { selectedNode: node, flowVariables, nodes } = useContext(BuilderContext);
  const { closeDrawer: cancel } = useDrawer();
  const [nodeData, setNodeData] = useState(node??{});
  const [currentAction, setCurrentAction] = useState({});
  const [actionType, setActionType] = useState(node.actionType??"");
  const [folder, setFolder] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [codeContent, setCodeContent] = useState('');
  const [copySuccess, setCopySuccess] = useState(false);

  const { TextArea } = Input;

  const [form] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const success = () => {
    message.success('Copied to clipboard');
  };


  useEffect(() => {
    // Fetch the data from sampleData using the key "GET_OUTLOOK_MAIL"
    const data = sampleData[0]["GET_OUTLOOK_MAIL"].data;
    const codeContent = JSON.stringify(data, null, 2);
    const codeExample = sampleData[0]["GET_OUTLOOK_MAIL"].Example;
  
    // Additional string header content
    const headerContent = "Output variable to capture the response.\nBelow is the sample response.";
  
    // Concatenate code content with header and example
    const fullContent = `${headerContent}\n\n${codeContent}\n\n${codeExample}`;
  
    // Set the content to the state variable
    setCodeContent(fullContent);
  }, []);


  const findAndUpdate = (arr, id, payload) => {
    let found = arr.findIndex((i) => i.id == id);
    if (found > -1) {
      arr[found] = { ...arr[found], ...payload };
    } else {
      arr.forEach((element) => {
        if (
          [
            "branch",
            "condition",
            "loop",
            "loop-nodes",
            "try",
            "try-catch-node",
            "review",
            "review-node",
          ].includes(element.type)
        ) {
          findAndUpdate(element.children, id, payload);
        }
      });
    }
    return arr;
  };

  const handleTypeChange = (e) => {
    if (e.target.value === "SEND_OUTLOOK_MAIL") {
      //nodeData[""] = [{ key: "", value: "" }]
      setCurrentAction(nodeData);
    }

    if (e.target.value === "OUTLOOK_GET_MAIL") {
      //nodeData[""] = []
      setCurrentAction(nodeData);
    }
    if (e.target.value === "SAVE_ATTACHMENT" || e.target.value === "OUTLOOK_MOVE_MAIL"
      || e.target.value === "OUTLOOK_DOWNLOAD_MAIL" || e.target.value === "OUTLOOK_SEND_REPLY_MAIL") {
      setCurrentAction(nodeData);
    }
    setActionType(e.target.value);
  };

  const handleGetFolder = async (e) => {
    const values = await form.validateFields();
    let {
      skillReducer: { trainDraft },
    } = store.getState();

    nodeData["folder"] = e.target.checked;
    nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
    let newActions = findAndUpdate(nodes, nodeData.id, nodeData);

    store.dispatch(
      setDraft({
        ...trainDraft,
        RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
      })
    );
  };

  const handleMarkAsRead = (e) => {
    let {
      skillReducer: { trainDraft },
    } = store.getState();

    nodeData["markAsRead"] = e.target.checked;
    nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
    let newActions = findAndUpdate(nodes, nodeData.id, nodeData);

    store.dispatch(
      setDraft({
        ...trainDraft,
        RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
      })
    );
  };

  const handleChange = async (e) => {
    let {
      skillReducer: { trainDraft },
    } = store.getState();

    nodeData.folder = e.target.value;
    setFolder(e.target.value);
    nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
    let newActions = findAndUpdate(nodes, nodeData.id, nodeData);

    store.dispatch(
      setDraft({
        ...trainDraft,
        RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
      })
    );
  };

  const handleMailType = (e) => {
    let {
      skillReducer: { trainDraft },
    } = store.getState();

    nodeData.mailType = e.target.value;
    nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
    let newActions = findAndUpdate(nodes, nodeData.id, nodeData);

    store.dispatch(
      setDraft({
        ...trainDraft,
        RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
      })
    );
  };

  const [mailForward, setMailForward] = useState(false);

  const handleReplyMail = (e) => {
    let {
      skillReducer: { trainDraft },
    } = store.getState();

    if(e.target.value == 3){
      setMailForward(true);
    }else{
      setMailForward(false);
    }
    nodeData.replyType = e.target.value;
    nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
    let newActions = findAndUpdate(nodes, nodeData.id, nodeData);

    store.dispatch(
      setDraft({
        ...trainDraft,
        RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
      })
    );
  };

  const validateVariableName = (variableName) => {
    if (variableName.includes("-") || variableName.includes(' ')) {
      dispatch(
        notify(
          "error",
          "Invalid variable name. The use of '-' symbol and spaces are not allowed in variable names."
        )
      );
      return false;
    }
    return true;
  };
  const newVariables = useSelector((state=> state.skillReducer?.trainDraft?.RAW_DATA?.variables))
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      let obj = {};
      let {
        skillReducer: { trainDraft },
      } = store.getState();
      if (actionType === "SEND_OUTLOOK_MAIL") {
        //nodeData.actionType = "SEND_OUTLOOK_MAIL";
        obj.actionType = "SEND_OUTLOOK_MAIL";
        obj.cc = values.cc ? values.cc : "";
        obj.body = values.body ? values.body : "";
        obj.bcc = values.bcc ? values.bcc : "";
        obj.subject = values.subject ? values.subject : "";
        obj.to = values.to ? values.to : "";
        obj.attachments = values.attachments ? values.attachments : "";
        nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
        let newActions = findAndUpdate(nodes, nodeData.id, obj);
        store.dispatch(
          setDraft({
            ...trainDraft,
            RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
          })
        );
        cancel();
      } else if (actionType === "OUTLOOK_GET_MAIL") {
        obj.actionType = "OUTLOOK_GET_MAIL";
        obj.key = "getMail";
        obj.label = "Get Outlook Mail";
        obj.description = "";
        obj.unRead = values.unRead ? values.unRead : "";
        obj.moveTo = values.moveTo ? values.moveTo : "";
        obj.top = values.top ? values.top : "";
        obj.folder = values.folder ? values.folder : "";
        const userVariable = values.variableName;
        const variableExists = newVariables?.some((variable) => variable.id !== nodeData.id && variable.name === userVariable);
        if (variableExists) {
          dispatch(
            notify(
              "error",
              "Duplicate variable names are not allowed."
            )
          );
          return false;
        }
        obj.variableName = values.variableName ? values.variableName : "";
        obj.custom = values.custom ? values.custom : "";
        // nodeData["folder"] = values.folder;
        // nodeData["variableName"] = values.variableName;
        if (values.variableName == null) {
        } else if (!validateVariableName(values.variableName)) {
          return;
        }
        nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
        let newActions = findAndUpdate(nodes, nodeData.id, obj);
        store.dispatch(
          setDraft({
            ...trainDraft,
            RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
          })
        );
        cancel();
      } else if (actionType === "SAVE_ATTACHMENT") {
        obj.actionType = "SAVE_ATTACHMENT";
        obj.filePath = values.filePath;
        obj.mailObject = values.mailObject;
        obj.label = "Save Attachment";
        obj.description = "";
        nodeData["mailType"] = nodeData.mailType
          ? nodeData.mailType
          : "outlook";
        nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
        let newActions = findAndUpdate(nodes, nodeData.id, obj);
        store.dispatch(
          setDraft({
            ...trainDraft,
            RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
          })
        );
        cancel();
      } else if (actionType === "OUTLOOK_MOVE_MAIL") {
        obj.actionType = "OUTLOOK_MOVE_MAIL";
        obj.foldernametoMoveMail = values.foldernametoMoveMail;
        obj.mailObject = values.mailObject;
        obj.label = "Move Mail";
        obj.description = "";
        nodeData["mailType"] = nodeData.mailType
          ? nodeData.mailType
          : "outlook";
        nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
        let newActions = findAndUpdate(nodes, nodeData.id, obj);
        store.dispatch(
          setDraft({
            ...trainDraft,
            RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
          })
        );
        cancel();
      }
      else if (actionType === "OUTLOOK_DOWNLOAD_MAIL") {
        obj.actionType = "OUTLOOK_DOWNLOAD_MAIL";
        obj.filePathDownloadMail = values.filePathDownloadMail;
        obj.mailObject = values.mailObject;
        obj.label = "Download Mail";
        obj.description = "";
        nodeData["mailType"] = nodeData.mailType
          ? nodeData.mailType
          : "outlook";
        nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
        let newActions = findAndUpdate(nodes, nodeData.id, obj);
        store.dispatch(
          setDraft({
            ...trainDraft,
            RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
          })
        );
        cancel();
      }
      else if (actionType === "OUTLOOK_SEND_REPLY_MAIL") {
        obj.actionType = "OUTLOOK_SEND_REPLY_MAIL";
        obj.replyType = nodeData?.replyType ? nodeData?.replyType : 1;
        obj.mailBody = values.mailBody;
        obj.mailObject = values.mailObject;
        obj.label = "Send Mail";
        obj.toAddress = values.toAddress ? values.toAddress : "";
        obj.ccAddress = values.ccAddress ? values.ccAddress : "";
        obj.description = "";
        nodeData["mailType"] = nodeData.mailType
          ? nodeData.mailType
          : "outlook";
        nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
        let newActions = findAndUpdate(nodes, nodeData.id, obj);
        store.dispatch(
          setDraft({
            ...trainDraft,
            RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
          })
        );
        cancel();
      }
    } catch (error) {
      console.log("form error");
    }
  };
  const renderActionFields = (type) => {
    switch (type) {
      case "SEND_OUTLOOK_MAIL":
        return (
          <div>
            <Form form={form} initialValues={nodeData}>
              <Form.Item
                name="to"
                label="To"
                rules={[
                  {
                    required: true,
                    message: 'Please enter valid email address',
                    validator: (_, value) => {
                      const hasBackquote = value.includes('`');

                      // Skip validation if value contains backquote
                      if (hasBackquote) {
                        return Promise.resolve();
                      }

                      // Validate email format if no backquote is present
                      const emailRegex = /^(\s*([^\s@]+@[^\s@]+\.[^\s@]+)\s*;*\s*)+$/;

                      if (!emailRegex.test(value)) {
                        return Promise.reject('Invalid email format');
                      }

                      return Promise.resolve();
                    }
                  }
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item name="cc" label="CC">
                <Input />
              </Form.Item>

              <Form.Item name="bcc" label="BCC">
                <Input />
              </Form.Item>

              <Form.Item
                name="subject"
                label="Subject"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>

              <Form.Item name="body" label="Body" rules={[{ required: true }]}>
                <TextArea />
              </Form.Item>

              <Form.Item
                name="attachments"
                label="Attachments"
                help="Eg: D:\myFolder\test.csv"
              >
                <Input />
              </Form.Item>
            </Form>
          </div>
        );
      case "OUTLOOK_GET_MAIL":
        return (
          <div>
            <Form.Item
              name="folder"
              label="Folder"
              rules={[{ required: true }]}
            >
              <Radio.Group
                onChange={(e) => handleChange(e, "folder")}
                checked={nodeData.folder}
              >
                <Radio value={"Inbox"}>Inbox</Radio>
                <Radio value={"Sent Items"}>Sent Items</Radio>
                <Radio value={"custom"}>Custom</Radio>
                <Radio value={"Deleted Items"}>Deleted Items</Radio>
              </Radio.Group>
            </Form.Item>
            {folder === "custom" || nodeData?.folder === "custom" ? (
              <Form.Item
                name="custom"
                label="Custom"
                help="Eg: Folder Name"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            ) : null}
            <Form.Item name="unRead" label="UnRead" help="Eg: true or false">
              <Input />
            </Form.Item>
            <Checkbox
              onChange={(e) => handleMarkAsRead(e, "markAsRead")}
              checked={nodeData.markAsRead}
              rules={[{ required: true }]}
            >
              {" "}
              Mark as Read{" "}
            </Checkbox>

            <Form.Item
              name="moveTo"
              label="Move to Folder"
              help="Eg: Customer1"
            >
              <Input />
            </Form.Item>

            <Form.Item
              rules={[{ required: true }]}
              name="top"
              label="Top"
              help="Eg: 10 or 25"
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="variableName"
              label="Enter Variable Name"
              help="Eg: variableName"
              rules={[{ required: true, message: 'Please enter a variable name' }]}
            >
              <Input />
            </Form.Item>

            <div className="ip-tl-label" style={{
              position: "relative",
              display: "inline-block",
              margin: "0",
              top: "-89px",
              left: "125px"
            }}>
              <a
                className="tlt-icon tl-tooltip task-table-info"
                href="javascript:void(0)"
                onClick={showModal}
              >
                <img src={info} alt="" />
              </a>
            </div>

            <Modal
              title="Reference"
              open={isModalOpen}
              onCancel={handleCancel}
              footer={null}
              className="scrollable-modal"
              style={{
                top: 20,
              }}
            >
              <CodeEditor value={codeContent} onChange={setCodeContent} />
              <div style={{ position: 'absolute', top: 10, right: 50 }}>
                <CopyToClipboard text={codeContent} onCopy={() => setCopySuccess(true)}>
                  <Button onClick={success} type="primary" icon={<CopyOutlined />}>
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
            </Modal>
          </div>
        );
      case "SAVE_ATTACHMENT":
        return (
          <div>
            Save Attachment
            <Form.Item>
              <Radio.Group
                defaultValue={nodeData.mailType ? nodeData.mailType : "outlook"}
                onChange={(e) => handleMailType(e, "mailType")}
                checked={nodeData.mailType}
              >
                <Radio value={"outlook"}>Outlook</Radio>
                {/* <Radio value={"Imap/pop3"}>IMAP/POP3</Radio> */}
              </Radio.Group>
            </Form.Item>
            <Form.Item
              rules={[{ required: true }]}
              name="filePath"
              label="Folder Path to Save Attachment"
              help="Eg: D:\myFolder `variableName`"
            >
              <Input />
            </Form.Item>
            <Form.Item
              rules={[{ required: true }]}
              name="mailObject"
              label="Mail Object"
              help="Eg: mail[index]"
            >
              <Input />
            </Form.Item>
          </div>
        );
      case "OUTLOOK_MOVE_MAIL":
        return (
          <div>
            Move outlook mail
            <Form.Item>
              <Radio.Group
                defaultValue={nodeData.mailType ? nodeData.mailType : "outlook"}
                onChange={(e) => handleMailType(e, "mailType")}
                checked={nodeData.mailType}
              >
                <Radio value={"outlook"}>Outlook</Radio>
                {/* <Radio value={"Imap/pop3"}>IMAP/POP3</Radio> */}
              </Radio.Group>
            </Form.Item>
            <Form.Item
              rules={[{ required: true }]}
              name="foldernametoMoveMail"
              label="Folder Name to move Mail"
              help="Eg: Outlookfoldername or `variablename`"
            >
              <Input />
            </Form.Item>
            <Form.Item
              rules={[{ required: true }]}
              name="mailObject"
              label="Mail Object"
              help="Eg: `mail[index]`"
            >
              <Input />
            </Form.Item>
          </div>
        );
      case "OUTLOOK_DOWNLOAD_MAIL":
        return (
          <div>
            Download Mail as Msg
            <Form.Item>
              <Radio.Group
                defaultValue={nodeData.mailType ? nodeData.mailType : "outlook"}
                onChange={(e) => handleMailType(e, "mailType")}
                checked={nodeData.mailType}
              >
                <Radio value={"outlook"}>Outlook</Radio>
                {/* <Radio value={"Imap/pop3"}>IMAP/POP3</Radio> */}
              </Radio.Group>
            </Form.Item>
            <Form.Item
              rules={[{ required: true }]}
              name="filePathDownloadMail"
              label="Folder path to download mail"
              help="Eg: D:\myfolder or `variablename`"
            >
              <Input />
            </Form.Item>
            <Form.Item
              rules={[{ required: true }]}
              name="mailObject"
              label="Mail Object"
              help="Eg: `mail[i]`"
            >
              <Input />
            </Form.Item>
          </div>
        );
      case "OUTLOOK_SEND_REPLY_MAIL":
        return (
          <div>
            {/* Reply Type */}
            <Form.Item label="Reply Type">
              <Radio.Group
                defaultValue={nodeData.replyType ? nodeData.replyType : 1}
                onChange={(e) => handleReplyMail(e)}
                // checked={nodeData.replyType}
              >
                <Radio value={1}>Reply</Radio>
                <Radio value={2}>Reply All</Radio>
                <Radio value={3}>Forward</Radio>
              </Radio.Group>
            </Form.Item>
           
            {mailForward ? (
               <>
                <Form.Item
                  rules={[{ required: true }]}
                  name="toAddress"
                  label="To Mail Address"
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  rules={[{ required: true }]}
                  name="ccAddress"
                  label="cc Mail Address"
                >
                  <Input />
                </Form.Item>
              </>
            ) : null}
            
            <Form.Item
              rules={[{ required: true }]}
              name="mailBody"
              label="Mail Body"
            >
              <TextArea />
            </Form.Item>
            <Form.Item
              rules={[{ required: true }]}
              name="mailObject"
              label="Mail Object"
              help="Eg: `mail[index]`"
            >
              <Input />
            </Form.Item>
          </div>
        );
    }
  };
  useEffect(() => {
  
    form.setFieldsValue(nodeData);

  }, [nodeData,form]);

  return (
    <div>
      {nodeData ? (
        <div>
          <Form className="" form={form} initialValues={nodeData}>
            <div className="ant-row ant-form-item">
              <label className="ant-form-item-required">Select Operation</label>
              <div className="ant-col ant-form-item-control">
                <select
                  className="ant-input"
                  style={{ padding: "10px" }}
                  value={actionType}
                  onChange={(e) => handleTypeChange(e)}
                >
                  <option>Select</option>
                  <option value="SEND_OUTLOOK_MAIL">Send Outlook Mail</option>
                  <option value="OUTLOOK_GET_MAIL">Get Outlook Mail</option>
                  <option value="SAVE_ATTACHMENT">Save Attachment</option>
                  <option value="OUTLOOK_MOVE_MAIL">Move Outlook Mail</option>
                  <option value="OUTLOOK_DOWNLOAD_MAIL">Download Outlook Mail</option>
                  <option value="OUTLOOK_SEND_REPLY_MAIL">Reply Outlook Mail</option>
                </select>
              </div>
            </div>

            {renderActionFields(actionType)}
          </Form>
          <GenAIConfigurer
            setNodeConfig={setNodeData}
            nodes={nodes}
            nodeData={nodeData}
            actionType={actionType}
          />
          <hr />
          <div>
            <Button onClick={cancel}> Cancel </Button>
            <Button type="primary" onClick={handleSubmit}>
              Save
            </Button>
          </div>
        </div>
      ) : null}

      <ul className="note-list">
        {(() => {
          if (actionType === "SEND_OUTLOOK_MAIL") {
            return (
              <li>
                Sends email from an outlook mailbox based on the given
                parameters.
              </li>
            );
          } else if (actionType === "OUTLOOK_GET_MAIL") {
            return (
              <li>
                Reads email from an outlook mailbox based on the given filter
                parameters.
              </li>
            );
          } else if (actionType === "SAVE_ATTACHMENT") {
            return (
              <li>Stores an outlook email attachment to the given folder.</li>
            );
          } 
           else if (actionType === "OUTLOOK_MOVE_MAIL") {
            return (
              <li>Move given mail object to respective outlook Folder.</li>
            );
          } 
           else if (actionType === "OUTLOOK_DOWNLOAD_MAIL") {
            return (
              <li>Download outlook mail as .msg attachment to the respective local folder.</li>
            );
          }
           else if (actionType === "OUTLOOK_SEND_REPLY_MAIL") {
            return (
              <li>Performs actions such as replying to or forwarding an existing Outlook email.</li>
            );
          } 
          else {
            return <li>Performs various actions on Outlook email.</li>;
          }
        })()}
      </ul>
    </div>
  );
};

export default SendMailConfigForm;
